// Muss mit appsettings.json VAPID:PublicKey im Backend übereinstimmen.
// Nur der Public Key gehört ins Frontend – niemals der Private Key.
const VAPID_PUBLIC_KEY = "BGqq2kOjuZnqoLK7DR1dc019DpNONdzhyxAtQDoLxczoRi5W8_Q91iSU2j3iC5WXCFkkZYsZraPfxv5IEs0W4Q0";

// applicationServerKey muss als Uint8Array übergeben werden.
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

class WebPushService {
  static hasPermission() {
    return Notification.permission === "granted";
  }

  static async requestPermission() {
    return await Notification.requestPermission();
  }

  // Race Condition beim allerersten Seitenaufruf:
  // getRegistration() schlägt sofort fehl, wenn (noch) kein SW registriert ist
  // (z.B. Dev-Modus oder beim ersten Laden, während der SW gerade installiert wird).
  // navigator.serviceWorker.ready wartet anschließend, bis der SW aktiv ist.
  // Ab dem zweiten Laden ist der SW bereits aktiv und getRegistration() liefert ihn direkt.
  static async getRegistration() {
    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      registration = await navigator.serviceWorker.ready;
    }
    return registration;
  }

  static async getSubscription() {
    const registration = await this.getRegistration();
    if (!registration) {
      return null;
    }
    return await registration.pushManager.getSubscription();
  }

  static async subscribe() {
    const registration = await this.getRegistration();
    if (!registration) {
      return null;
    }
    // Vorhandene Subscription wiederverwenden, sonst neu anlegen.
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }
    return subscription;
  }

  // Berechtigung anfragen, subscriben und die Subscription ans Backend POSTen.
  static async subscribeAndRegister(httpService) {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      return null;
    }
    const permission = await this.requestPermission();
    if (permission !== "granted") {
      return null;
    }
    const subscription = await this.subscribe();
    if (!subscription) {
      return null;
    }
    const json = subscription.toJSON();
    // Feldnamen passend zum Backend-DTO Subscription { Endpoint, P256dh, Auth }.
    await httpService.post("AccountAPI/Subscription", {
      Endpoint: json.endpoint,
      P256dh: json.keys.p256dh,
      Auth: json.keys.auth,
    });
    return subscription;
  }

  // Browser-Subscription beenden und Eintrag im Backend löschen.
  static async unsubscribe(httpService) {
    const subscription = await this.getSubscription();
    if (subscription) {
      const json = subscription.toJSON();
      await subscription.unsubscribe();
      if (httpService) {
        // Backend löscht gerätegenau über Endpoint (DeleteSubscriptionModel { Endpoint }).
        await httpService.delete("AccountAPI/Subscription", {
          data: { Endpoint: json.endpoint },
        });
      }
    }
    return subscription;
  }
}

export default WebPushService;
